angular.module('app.controllers').controller('ContactModalCtrl', ['$scope', '$rootScope', 'APIForm', 'UI', 'APIInquiries', 'APIFavorites', '$cookies'].append(function(self, root, APIForm, UI, APIInquiries, APIFavorites, $cookies) {
  self.data = null;
  self.formProccess = false;
  self.formSuccess = false;
  self.saveForm = function(form) {
    return self.cForm = form;
  };
  self.contactModalEl = document.getElementById('contactModal');
  if (self.contactModalEl) {
    self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl);
    self.contactModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.data = null;
      self.inquiry = null;
      self.formProccess = false;
      self.formSuccess = false;
      self.cForm.$setPristine();
      self.cForm.$setUntouched();
      return self.$applyAsync();
    });
    self.contactModalEl.addEventListener('show.bs.modal', function(event) {
      return self.$applyAsync();
    });
  }
  self.$on('onContactModalOpen', function(event, email = '', name = '', favs = false) {
    var ref, ref1, ref2, ref3, ref4;
    self.fake = {
      themes: []
    };
    if (favs) {
      return APIFavorites.query({
        shortcode: ((ref = root.user) != null ? ref.shortcode : void 0) || root.tuser || 'test',
        tuser: root.tuser || null,
        _themes: true,
        lang: root.lang || 'es'
      }, function(data) {
        self.themes = data;
        self.data = {
          favs: favs,
          favs_themes: ''
        };
        return self.contactModal.show();
      });
    } else {
      self.data = {
        to_email: email,
        to_name: name,
        email: ((ref1 = root.session) != null ? (ref2 = ref1.user) != null ? ref2.email : void 0 : void 0) || 'noreply@mailer.dmas.at',
        name: ((ref3 = root.session) != null ? (ref4 = ref3.user) != null ? ref4.name : void 0 : void 0) || 'Playground User',
        message: '',
        favs: favs,
        favs_themes: ''
      };
      return self.contactModal.show();
    }
  });
  self.setFavsThemes = function() {
    var tempEntry_id;
    self.formProccess = true;
    self.formSuccess = false;
    self.data.favs_themes = self.fake.themes.join(", ");
    tempEntry_id = Date.now();
    return self.toggleFavs('cr', {
      entry_id: tempEntry_id,
      exhibitor_id: 1,
      favs_themes: self.data.favs_themes
    });
  };
  root.$on('finishContactRequest', function(event) {
    self.formProccess = false;
    return self.formSuccess = true;
  });
  return self.sendContact = function() {
    var description, ref;
    self.formProccess = true;
    description = [`Email: ${self.data.to_email}`, `Name: ${self.data.to_name}`, `Message: ${self.data.message}`];
    if (self.data.favs) {
      description.unshift(`Theme: ${self.data.favs_themes}`);
    }
    self.inquiry = new APIInquiries({
      title: "Kontakt",
      methods: ['notice'],
      shortcode: (ref = root.user) != null ? ref.shortcode : void 0,
      exhibitor_id: null,
      description: description.join("\n")
    });
    return (new APIForm(self.data)).$save({
      lang: root.lang || 'es'
    }, function(data) {
      var ref1, ref2;
      //now = new Date()
      //$cookies.put('s_e365_theme', 1, {expires: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)}) if self.data.favs
      if ((ref1 = root.user) != null ? ref1.auth_ticket : void 0) {
        self.inquiry.$save({
          _private: true,
          auth_ticket: (ref2 = root.user) != null ? ref2.auth_ticket : void 0
        }, function(data) {
          return self.customStat(null, 'send_message', `Contact to ${self.data.to_email}: ${self.data.message}`);
        }, function(response) {
          return UI.notify(false, response.data.error);
        });
      } else {
        self.customStat(null, 'send_message', `Contact to ${self.data.to_email}: ${self.data.message}`);
      }
      if (data.success) {
        self.formSuccess = true;
      }
      self.cForm.$setPristine();
      return self.cForm.$setUntouched();
    }, function(response) {
      self.formProccess = false;
      return UI.notify(false, response.data.error);
    });
  };
}));
